<template>
  <tabs-options-data v-if="quoteTo === 'cxTabs'" :options="options" :myid="myid" />
  <div v-else>
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div class="data-source-type">
          <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
          <div v-show="noCacheComponent">
            <!-- <div class="dataSource-item mt12" @click="goToChooseData">
              <span>进入数据管理后台 </span>
            </div> -->
            <data-center-choose 
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              class="mt12"
              @onDataCenterChange="onDataCenterChange"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        class="dataContent"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据内容"
        name="2"
      >
        <edit-table v-if="!noCacheComponent" @change="updateTableData" :maxRow="2000" :tableData="formateSelectData" class="mb16"></edit-table>
        <cx-check-box :value.sync="open1">点击跳转链接</cx-check-box>
        <div v-show="open1" class="content-item mt16 verticallyCenter clearFloat">
          <div class="font14 mr16 no-break">跳转至</div>
          <el-radio-group v-model="openBlankPage">
            <el-radio label="新页面">新页面</el-radio>
            <el-radio label="当前页面">当前页面</el-radio>
          </el-radio-group>
        </div>
        <cx-check-box :value.sync="deliverMhParams" class="mt16">携带系统参数</cx-check-box>
      </el-collapse-item>
      <el-collapse-item v-show="noCacheComponent" @mousedown.native="collapseMouseDown($event, '3')" title="更多" name="3">
        <div class="data-source-type">
          <auto-update-timer/>
          <!-- <div class="getDataBtn" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
          <cx-check-box v-if="request_prefix === 'bigScreen'" :value.sync="usePageQuery" class="mt16">
            开启跨页面传参
          </cx-check-box>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import tabsOptionsData from "../../tabs/toolbars/tabs-options-data"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
import {getAppointCacheData} from "utils/updateData/publicDataUtils/getRestClassify";
export default {
  components: {
    tabsOptionsData,
    autoUpdateTimer,
    dataCenterChoose
  },
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
      activeIndex: 0,
      fetchEnd: false,
      dataOptions: [{ value: false, title: "本地数据" }, { value: true, title: "数据中心" }]
    }
  },
  watch:{
    deliverMhParams: {
      handler: function () {
        this.highSet()
      },
      deep: false
    },
  },
  computed: {
    quoteTo() {
      return this.options.quoteTo
    },
    ids() {
      return this.$store.state.states.activeID
    },
    open1: {
      get() {
        if (!this.options.hasOwnProperty("open")) {
          this.$changeOptionsEV(true, "open", false, false, false, true)
        }
        return this.options.open
      },
      set(val) {
        this.$changeOptionsEV(val, "open", false)
      }
    },
    deliverMhParams:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "deliverMhParams", "deliverMhParams", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "deliverMhParams", false)
      }
    },
    selectOptionsData: {
      get() {
        return this.options.selectOptions || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectOptions", false)
      }
    },
    formateSelectData() {
      const res = []
      this.selectOptionsData
        .filter(item => item)
        .forEach(item => {
          res.push([
            ["名称", item.label],
            ["链接", item.value]
          ])
        })
      return res
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(["", newVal], ["value", "noCacheComponent"], false, null)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage ? "新页面" : "当前页面"
      },
      set(newVal) {
        let temp = true
        if (newVal == "新页面") {
          temp = true
        } else {
          temp = false
        }
        this.$changeOptionsEV(temp, "openBlankPage", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    },
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
   async highSet() {
      let publicId = this.options.engineInstanceId
      if(!publicId){
        const data =  await this.getAppointDataEv() || {}
        publicId = data.engineInstanceId
      }
      this.$API
          .updateAppAttr({
            param: {
              publicId: publicId,
              deliverMhParams: this.deliverMhParams
            }
          })
          .then(res => {
            if (res.data.code === 1) {
            }
          })
    },
    async getAppointDataEv() {
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId ? this.options.appId : this.options?.myFetchParam?.appId
      return await getAppointCacheData.call(
          this,
          pageId,
          wfwfid,
          websiteId,
          appId
      )
    },
    updateTableData(type, rowIndex, colKey, key, value) {
      if (colKey < 3) {
        if (type === "update") {
          let changeKey = "selectOptions." + rowIndex
          switch (key) {
            case "名称":
              changeKey = changeKey + ".label"
              break
            case "链接":
              changeKey = changeKey + ".value"
              break
            default:
              break
          }
          this.$changeOptionsEV(value, changeKey, false)
        } else {
          const changeKey = "selectOptions." + this.selectOptionsData.length
          const changeValue = {}
          switch (colKey) {
            case 0:
              changeValue.label = value
              changeValue.value = ""
              break
            case 1:
              changeValue.value = ""
              changeValue.coord = value
              break

            default:
              break
          }
          this.$changeOptionsEV(changeValue, changeKey, false)
        }
      } else if (type === "delete" && typeof rowIndex === "number") {
        const newScatterData = JSON.parse(JSON.stringify(this.selectOptionsData))
        newScatterData.splice(rowIndex, 1)
        this.$changeOptionsEV(newScatterData, "selectOptions", false)
      } else {
        this.$message({
          type: "error",
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "该列数据为无效数据，请勿修改"
        })
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时", false)
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(
          this,
          datas => {
            let data = []
            datas.forEach(item => {
              data.push({
                label: item[Object.keys(item)[0]].value,
                value: item[Object.keys(item)[1]].value
              })
            })
            this.selectOptionsData = data
          },
          15,
          1
        )
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    async getAppointData() {
      return this.instance.get(`engine2${this.restDataUrl.slice(8)}&p2=1`)
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.data-source-type::v-deep .el-radio {
  margin-bottom: 16px;
}
.data-source-type::v-deep .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.el-radio {
  margin-right: 8px;
}
.el-radio:last-child {
  margin-right: 0;
}
</style>
